import { setCurrentChatSession, ChatAPI } from '@guuru/chat-web';
import { delay as sleep } from '@guuru/helpers-common';
import createChat from './createChat';
import handleChatStatusChange from './handleChatStatusChange';
import transferChat from './transferChat';

export default async function (partnerId, { handover, targetId } = {}) {
  const { chatId, updatedChat } = await createChat(partnerId);

  if (!chatId) return;

  await sleep(ChatAPI.getBotEllipsisMessageDelay());

  const { status } = await transferChat(partnerId, chatId, {
    handover,
    targetId,
  });

  setCurrentChatSession({
    chatId,
    messages: updatedChat?.messages?.edges,
  });
  handleChatStatusChange({ chatId, ...updatedChat, status });
}
